import Vue from "vue";

import LayoutBreadcrumbCartao from "./LayoutBreadcrumbCartao/LayoutBreadcrumbCartao";
import Accordion from "./Accordion/Accordion";
import Multiselect from "./Multiselect/Multiselect";

Vue.component("accordion", Accordion);
Vue.component("layout-breadcrumb-cartao", LayoutBreadcrumbCartao);
Vue.component("rnp-multiselect", Multiselect);
